

$(window).on('load', function() {

$('.addtocart.nostock').each(function(){
  $(this).find('span').text('Notify me')
})
})

$("body").on("click", ".DiscountCodeModule_DiscountCodeModule__form__cTmjN button", function(event){
if($('.disount_future').length){
  var code=$('.disount_future').attr('code');
  var codetext=$('.disount_future').attr('codetext');
var hst=$('input.upcart-discount-code-input').val();
  console.log(hst)
    $('.durin_sale_popup').remove();
  if(hst==code){
    setTimeout(function(){
      
  
    $('.upcart-discount-code-module').prepend('<p class="durin_sale_popup">'+codetext+'</p>')
      
    },1500)
  }
}
})
$("body").on("click", ".variant-input-wrap label", function(event){
var hitname=$(this).attr('hitname');
  $('.product__thumb-item.no_hide').attr('data-group',hitname)

})

$("body").on("click", ".optonsbundle div", function(event){
 
  // console.log('dd')
var hs=$(this).parent().attr('nme')
  var filename=$(this).attr('filename')
var vl=$(this).attr('value');
  $(this).parent().find('h3 span').text(vl);
  $(this).parent().find('div').removeClass('active');
  $(this).addClass('active')
  var pid=$(this).parent().attr('pid');
  $('div#simple-bundles-io-options select#'+pid+'').find("option:selected").prop("selected", false)
  $('div#simple-bundles-io-options select#'+pid+'').find('option[value="'+vl+'"]').prop("selected", true);
  $('input[type="hidden"][name="'+hs+'"]').attr('value',vl);
    
setTimeout(function(){
 var getinds=$('.product__thumbs--beside .product__thumb-item[data-group="'+filename+'"]').index()

$('.product__thumbs--beside .product__thumb-item[data-group="'+filename+'"] a')[0].click() 
},10)
 var sum_new=''
setTimeout(function(){
  var gtbnle=Number($('.optonsbundle').length);
      var h=1;
$('.optonsbundle').each(function(){
var gsltc=$(this).find('div.active').attr('value');
  

  if(h == gtbnle) {
    var nme=$(this).attr('nme')
    // console.log('last item'+gsltc)
    sum_new += gsltc
  }else{
  sum_new += gsltc+' <> ';

    
  }
  h++;
   
})
 

  
 $('input[name="properties[_bundle_selection]').attr('value',sum_new)
},1000)
  

})


$("#Form-dealerinq-10").on("change", function () {
        $("#Form-dealerinq-11").css("display", "none");
        $("Form-dealerinq-11").css("display", "none");
        if ($(this).val() == "Other") {
          $("#Form-dealerinq-11").css("display", "block");
        }
      });
       $("#Form-dealerinq-12").on("change", function () {
        $("#Form-dealerinq-13").css("display", "none");
        $("Form-dealerinq-13").css("display", "none");
        if ($(this).val() == "Other") {
          $("#Form-dealerinq-13").css("display", "block");
        }
      });
$('.filter--area .filter--options div').click(function(){
  
  if($(this).parent('.filter--options.active').length){
    
    console.log('test12')
     $('.filter--options').removeClass('active');
     $('.select---grid').slideUp();
  }else{
     console.log('test12no')
     $('.select---grid').slideUp();
   var gethit=$(this).parent('.filter--options').attr('type');
    console.log(gethit)
      $('.select---grid[hit="'+gethit+'"]').slideDown();
    $('.filter--options.active').removeClass('active');
    $(this).parent('.filter--options').addClass('active')
  }
  
})
 

$("body .product--lists").on("click", ".addtocart", function(event){
  if($(this).hasClass('red-p-dr')){

var rhref=$(this).prev('a').attr('href')
    window.location.href=rhref
  }else{

  if($(this).parent().find('.custom.grid-product__colors').length){
    
  var that=$(this);  
  $(this).parent().find('.addtocart span').text('Adding to cart');
var ID =$(this).parent().find('.trgtDiv.active').attr('vrtid');
   console.log('done---'+ID);

$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
}, 
  dataType: 'json', 
 success: function (data) { 
 console.log('done');
  document.dispatchEvent(new CustomEvent('cart:build'));
that.addClass('active');
   that.find('.addtocart span').text('Added to cart');
     document.dispatchEvent(new CustomEvent('cart:open'));

    
 } 
 });


  }else{




    var that=$(this);  
  $(this).find('span').text('Adding to cart');
var ID =$(this).find('.trgtDiv.active').attr('vrtid');
   console.log('done'+ID);

$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
}, 
  dataType: 'json', 
 success: function (data) { 
 console.log('done');
  document.dispatchEvent(new CustomEvent('cart:build'));
that.addClass('active');
   that.find('span').text('Added to cart');
     document.dispatchEvent(new CustomEvent('cart:open'));

    
 } 
 });



    
  }

setTimeout(function(){
   freeshiping()
},1000)
 
}
})
var steps = 50;
		
$("body").on("click", ".trgtDiv", function(event){
  var varianturl=$(this).attr('varianturl');
  var variantprice=$(this).attr('variantprice');
  var comprePrice=$(this).attr('compre');
    var off=$(this).attr('off');
    console.log(comprePrice+'???')
    if(off != '' && off != undefined){
  $(this).parent().parent().parent().find('.sale_bubble').css('display','flex')
    $(this).parent().parent().parent().find('.sale_bubble').text(off+'% off')
    }else{
        $(this).parent().parent().parent().find('.sale_bubble').hide()
    }
  if(comprePrice != '' && comprePrice != undefined){
    console.log(comprePrice+'---')
    $(this).parent().parent().parent().find('.product--price p.money_d').text(comprePrice)
     $(this).parent().parent().parent().find('.product--price p.money_d').show();
    
    
  }else{
    
     $(this).parent().parent().parent().find('.product--price p.money_d').hide();
  }
  $(this).parent().parent().parent().find('.product--price span').text(variantprice);
  $(this).parent().parent().parent().find('a').attr('href',varianturl);
  if($(this).hasClass('outstock')){
    $(this).parent().parent().parent().find('.addtocart').addClass('nostock');
     $(this).parent().parent().parent().find('.addtocart span').text('Notify me');
  }else{
$(this).parent().parent().parent().find('.addtocart').removeClass('nostock');
    $(this).parent().parent().parent().find('.addtocart span').text('Add to cart');
     
  }
var vrianimg=$(this).attr('vriant--img');
  $(this).parent().parent().parent().find('.image--area img.first-img').attr('src',vrianimg);
$(this).parent().find('.trgtDiv').removeClass('active');
  $(this).addClass('active')
  if($(this).hasClass('addscroll')){
    
  $(this).parent(".grid-product__colors.custom").animate({
				scrollLeft: "+=" + steps + "px"
			});
  }
})


$("body .collection--filter").on("click", "ul.colr--lists li", function(){
  console.log('test124')
   var bgimg= $(this).find('img').attr('srcset');
  $('.top--banrs img').attr('srcset',bgimg);
  $('ul.colr--lists li').removeClass('active');
  var that=$(this);
    that.addClass('active');
  $('.collection--filter ul.colr--lists').addClass('low---opacity')
 $('div#collection--product').html('<div class="loader"></div>');

var urlgt=$(this).attr('href');
    history.pushState(null, '', urlgt);

  $.ajax({
type: 'GET',
url: urlgt,
 success: function (data) {
 var product = data;
		var gthtml=$(product).find('#collection--product').html();
   var getheading=$(product).find('.collection-page-banner h3').text();
    var getdesc=$(product).find('.collectionDescription').text();
     var crntlction=$(product).find('.cuurent--collection').attr('url');
   $('.cuurent--collection').attr('url',crntlction);
  $('.collection-page-banner .collectionDescription').text(getdesc);
   $('.collection-page-banner h3').text(getheading);
   $('div#collection--product').html(gthtml);
 $('.select---grid ul li.active').removeClass('active');
    $('b.amountcoor').hide();
   $('.filter--area .filter--options.active').removeClass('active');
   $('.filter-selction .select---grid').slideUp();
   $('.collection--filter ul.colr--lists').removeClass('low---opacity')

  
  if(urlgt.indexOf('=Fav') != -1){

fav()

  }

$('.addtocart.nostock').each(function(){
  $(this).find('span').text('Notify me')
})
 } 
 });

}) 
$('.select---grid .all--bottles ul li').click(function(){
if($(this).hasClass('active')){
  $('div#collection--product').html('<div class="loader"></div>');
     $('.all--bottles ul li').removeClass('active')
   
   var gturl=$('.cuurent--collection').attr('url');
   $.ajax({
type: 'GET',
url: concturl,
 success: function (data) {
 var product = data;
		var gthtml=$(product).find('#collection--product').html();
   
   $('div#collection--product').html(gthtml);

var i=0;
   if($('.select---grid .all-colors li.active').length){
  chckclr()
}
   

  
 } 
 });

   $('.filter--options.filter2  b.amountcoor').hide();
  }else{
  $('.filter--options.filter2  b.amountcoor').show();
    $('.all--bottles ul li').removeClass('active')
     $(this).addClass('active');
  
 $('div#collection--product').html('<div class="loader"></div>');
 var btl=$(this).attr('btl');
  var gturl=$('.cuurent--collection').attr('url');
var i=0;
  var sum_new='';
  $('.select---grid .all--bottles li.active').each(function(){
 
  var btl= $(this).attr('btl')
   
    sum_new += btl+'+';

i++;
})




  console.log(sum_new+'-----')
 
  var concturl=gturl+'/'+sum_new;
    // history.pushState(null, '', concturl);
  // if(i==0){
  //   $('.filter2 b.amountcoor').hide();
  // }else{
  //    $('.filter2 b.amountcoor').show();
  //    $('.filter2 b.amountcoor').text(i);
  // }



   $.ajax({
type: 'GET',
url: concturl,
 success: function (data) {
 var product = data;
		var gthtml=$(product).find('#collection--product').html();
   
   $('div#collection--product').html(gthtml);

var i=0;
   if($('.select---grid .all-colors li.active').length){
  chckclr()
}
   
 // $('html, body').animate({
 //        scrollTop: $(".filter--options.active div#filtr--scl").offset().top
 //    }, 200);
  
 } 
 });
 }
  
})
$('.select---grid .all-colors ul li').click(function(){

  var i=0;
  if($(this).hasClass('active')){
 
    
    window.history.pushState({}, '', 'https://puffindrinkwear.com/collections/all-products');
     $('.all-colors ul li').removeClass('active')
    $('.trgtDiv').removeClass('hidevriant')
    $('.product--item.hideparent').removeClass('hideparent')
       $('.product--options .grid-product__colors.custom').removeClass('rollfirst')
     $('.filter--options.filter1 b.amountcoor').hide();
    
  }else{
    $('.filter--options.filter1 b.amountcoor').show();
    $('.product--options .grid-product__colors.custom').addClass('rollfirst')
    $('.all-colors ul li').removeClass('active')
     $(this).addClass('active');

  
   var gtclr=$(this).attr('clr');
$('.showmore---img').trigger('click')
  $('div#collection--product .product--item').each(function(){
var that=this
    $(that).addClass('hideparent');
    $(that).find('.grid-product__colors.custom .trgtDiv').each(function(){
      var those=this
       $(those).addClass('hidevriant')
     var trigerclr= $(those).attr('trigerclr');
       var activeon= $(those).attr('activeon');
      if(activeon.indexOf(gtclr) != -1){
  $(those).removeClass('hidevriant')
        $(that).addClass('active');
  $(that).removeClass('hideparent');
         $(those).addClass('tiigrclick')
  var clns=$(those).clone();
  $(those).parent().prepend(clns)
  $(those).remove();
       $('.tiigrclick').trigger('click')
        $('.tiigrclick').removeClass('tiigrclick')
      }
if(trigerclr.indexOf(gtclr) != -1){
  
  $(those).removeClass('hidevriant')
        $(that).addClass('active');
  $(that).removeClass('hideparent');
  
     i++;
      }
      
      
    })
    
  })

 if(i==0){
   $('.noresult---hide').removeClass('hide')
 }else{
    $('.noresult---hide').addClass('hide')
 }
  // $('html, body').animate({
  //       scrollTop: $(".filter--options.active div#filtr--scl").offset().top
  //   }, 200);
      const url = new URL(window.location);
url.searchParams.set('color', gtclr);
window.history.pushState({}, '', url);
  }
 });

var step = 200;
		var scrolling = true;
		// Wire up events for the 'scrollUp' link:
			$("body").on("click", ".showmore---img", function(event){

				event.preventDefault();
              $(this).parent(".grid-product__colors.custom").find('.trgtDiv').addClass('addscroll');
			$(this).parent(".grid-product__colors.custom").animate({
				scrollLeft: "+=" + step + "px"
			});
          $(this).remove();
		});
function chckclr(){
     
 var gtclr=$('.select---grid .all-colors li.active').attr('clr');
$('.showmore---img').trigger('click')
  $('div#collection--product .product--item').each(function(){
var that=this
    $(that).addClass('hideparent');
    $(that).find('.grid-product__colors.custom .trgtDiv').each(function(){
      var those=this
       $(those).addClass('hidevriant')
     var trigerclr= $(those).attr('trigerclr');
       var activeon= $(those).attr('activeon');
      if(activeon.indexOf(gtclr) != -1){
$(those).trigger('click')
       
      }
if(trigerclr.indexOf(gtclr) != -1){
  $(those).removeClass('hidevriant')
        $(that).addClass('active');
  $(that).removeClass('hideparent');
     i++;
      }
      
      
    })
    
  })

 if(i==0){
   $('.noresult---hide').removeClass('hide')
 }else{
    $('.noresult---hide').addClass('hide')
 }
}
setTimeout(function(){
  $('div#collection--product .product--item').each(function(){
    $(this).find('.instock.trgtDiv.active')[0].click();
  })
},500)

function fav(){
   setTimeout(function(){

var gtclr='Fav';
     $('div#collection--product .product--item').each(function(){
var that=this
     $('.product--options.havegreatr .grid-product__colors.custom .trgtDiv').show();
       $('.showmore---img').remove();
       var i=1;
    $(that).find('.grid-product__colors.custom .trgtDiv').each(function(){
      var those=this
       $(those).addClass('hidevriant')
   
     var activeon= $(those).attr('activeon');
  
if(activeon.indexOf(gtclr) != -1){
  if(i==1){
    $(those).trigger('click');
    
  }
  i++;
 $(those).removeClass('hidevriant')
  
     
      }
      
      
    })
    
  })
 
   },1000)
}

if($('body').hasClass('template-collection')){
 if(window.location.href.indexOf("Fav") > -1) {
 
  
    fav()

}else if(window.location.href.indexOf("?color=") > -1) {
 
   
  setTimeout(function(){
var url=window.location.href;
 var getclrname=url.split('=');
  var clrnam=getclrname[1];
    $('.select---grid ul li[clr="'+clrnam+'"]').addClass('active');
    
$('.showmore---img').trigger('click')
  $('div#collection--product .product--item').each(function(){
var that=this
    $(that).addClass('hideparent');
    $(that).find('.grid-product__colors.custom .trgtDiv').each(function(){
      var those=this
       $(those).addClass('hidevriant')
     var trigerclr= $(those).attr('trigerclr');
       var activeon= $(those).attr('activeon');
      if(activeon.indexOf(clrnam) != -1){
  $(those).removeClass('hidevriant')
        $(that).addClass('active');
  $(that).removeClass('hideparent');
         $(those).addClass('tiigrclick')
  var clns=$(those).clone();
  $(those).parent().prepend(clns)
  $(those).remove();
       $('.tiigrclick').trigger('click')
        $('.tiigrclick').removeClass('tiigrclick')
      }
if(trigerclr.indexOf(clrnam) != -1){
  
  $(those).removeClass('hidevriant')
        $(that).addClass('active');
  $(that).removeClass('hideparent');
  
     i++;
      }
      
      
    })
    
  })
    $('.filter--area .filter--options span b.amountcoor').addClass('tes')
    setTimeout(function(){
      
$('.filter--area .filter--options.filter1 span b.amountcoor').show();
    
    },1200)
 

 
   },1000)
    }  

}
$(window).scroll(function() {
  if($("#inviewport").length){
    var top_of_element = $("#inviewport").offset().top;
    var bottom_of_element = $("#inviewport").offset().top + $("#inviewport").outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
      
      if($('#inviewport').hasClass('act')){
       
      }else{
      }
    } else {
         console.log('novisible')
    }
  }
});
jQuery(".slick-slider").slick({
  dots: false,
arrows: true,
infinite: true,
   centerMode: true,
  centerPadding: '60px',
  slidesToShow: 3,
speed: 300,  responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow:1,
                slidesToScroll: 1
            }
        }

  ]
                              });

setTimeout(function(){
  jQuery(".slick-slider").slick('slickGoTo', 2);
},1000)

// setTimeout(function(){
  
// var gtbg=$('.puffin-product--image').attr('data-background-image-urls');
// $('.puffin-product--image').attr('data-background-image-url',gtbg)
  
// },3000)
